import { browser } from "$app/environment";
import config from "@/config/index.js";
import { EXPERIMENT_NAMES } from "@/constants/experimentConstants.js";
import experimentStore from "@/stores/experimentStore.js";
import { initSentry } from "@/sentry/load";

export type EXPERIMENT_OBJ_TYPE = {
  [key: string]: string;
};

export const ssr = false;

const initializeSentry = () => {
  experimentStore.subscribe((expObj: EXPERIMENT_OBJ_TYPE) => {
    const { expId: mojSentryExpId } = config.experimentsList.find(
      ({ expName }) => expName === EXPERIMENT_NAMES.MOJ_SENTRY.name
    );
    const isSentryEnabled =
      expObj[mojSentryExpId] === EXPERIMENT_NAMES.MOJ_SENTRY.variants.VARIANT1;
    if (isSentryEnabled && !window.Sentry) {
      initSentry();
    }
  });
};

export const load = async () => {
  if (browser) {
    initializeSentry();
  }
};
